import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import lngKo from './lngKo.json';
import lngEn from './lngEn.json';

const resources = {
    'ko': {
        translation: lngKo
    },
    'en': {
        translation: lngEn
    }
};

i18n.use(initReactI18next)
    .init({
        resources: resources,
        lng: "ko",
        fallbackLng: "ko",
        debug: false,
        defaultNS: 'translation',
        ns: 'translation',
        keySeparator: false,
        interpolation: {
            escapeValue: false
        }
    });

export default i18n;